import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
//import Box from '@material-ui/core/Box';
//import Container from '@material-ui/core/Container';
import InputAdornment from '@material-ui/core/InputAdornment';
import { withStyles } from '@material-ui/styles';
import { Field, reduxForm } from 'redux-form';
import { setPropsAsInitial } from '../helpers/setPropsAsInitial';
import { isMobile, isBrowser, isChrome } from 'react-device-detect';
import { Grid/* , Fab */ } from '@material-ui/core';
//import FingerprintIcon from '@material-ui/icons/Fingerprint';
import LockIcon from '@material-ui/icons/Lock';
import PersonIcon from '@material-ui/icons/Person';
import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { history } from '../helpers/history';
import { ArrowBack, LockOpen } from '@mui/icons-material';
import { Divider } from '@mui/material';
import moment from 'moment';

const useStyles = theme => ({
  paper: {

    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%', // Fix IE 11 issue.
    //marginTop: 1,
    ///backgroundColor: "#EEEFF2",
    padding: "1% 6% 6% 6%",
    //borderRadius: "8px",
    //border: "3px solid #EEEFF2"
  },
  avatar: {
    margin: 1,
    backgroundColor: 'red',
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    //marginTop: 1,
    backgroundColor: "#fff",
    padding: "1% 6% 6% 6%",
    borderRadius: "8px",
    //border: "3px solid #EEEFF2"
    boxShadow: "1px 1px 10px 0px #00000044"

  },
  submit: {
    margin: (3, 0, 2),
    fontWeight: 'bold',
    fontSize: '0.9rem',
    color: 'white',
    backgroundColor: "#0097a0",
    "&:hover": {
      backgroundColor: "#0097a0"
    },
    borderRadius: "8px",
    border: "1px solid #fffffe"
  },
  logo: {
    width: '70%',
    height: '70%'
  },
  footer: {
    width: '5%',
    height: '5%'
  },
  button_header: {
    marginTop: 20,
  },
  grid_header: {
    marginTop: 12,
    gap: "8px",
  },
  copyright: {
    justifyContent: 'space-between'
  },
  multilineColor: {
    color: 'red'
  },
  root: {
    background: "red"
  },
  input: {
    color: "white"
  },
  title: {
    color: 'rgb(0, 0, 1)',
    fontWeight: 'bold',
    fontSize: '1.75rem'
  },
  button: {
    fontSize: '0.875rem',
    color: 'white',
    background: '#2E2757',
    "&:hover": {
      backgroundColor: "#2E2757"
    },
    borderRadius: "8px",
    border: "1px solid #2E2757"
  },
  line: {
    backgroundColor: '#2E2757',
    height: '1px',
    width: '100%'
  },
  button_login: {
    marginTop: '10px',
    fontSize: '0.875rem',
    color: '#351164',
    backgroundImage: `url(${process.env.PUBLIC_URL + '/images/fondo_boton.png'})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    "&:hover": {
      //backgroundImage: `url(${process.env.PUBLIC_URL + '/images/fondo_boton.png'})`,
      //color: '#000',
      boxShadow: '0 4px 16px #2E2757',
      transition: 'all 0.2s ease',
    },
    '&.Mui-disabled': {
      color: '#2E2757',
    },
    borderRadius: "8px",
    border: "1px solid #2E2757",
    //fontFamily: "MyriadPro-SemiBold"
  },
  buttonLogin: {
    fontSize: '0.875rem',
    color: 'white',
    background: 'linear-gradient(180deg, #2E2757 5%, #351164 100%)',
    "&:hover": {
      background: 'linear-gradient(180deg, #2E2757 5%, #351164 100%)',
    },
    borderRadius: "8px",
    border: "1px solid #2E2757",
    //fontFamily: "MyriadPro-Bold"
  }
});

const validate = values => {
  const error = {}
  if (!values.username || values.username === "") {
    error.username = `El campo Usuario es obligatorio`
  }
  if (!values.password || values.password === "") {
    error.password = `El campo Contraseña es obligatorio`
  }
  return error
}

/* function Copyright(classes) {
  return (
    <div >
      <Grid container className= {classes.grid_header} justify="center" alignItems="center" direction="row">
          <img src={process.env.PUBLIC_URL + '/images/footer_cb.png'} alt="Logo" style= {{width: '70%'}} />
      </Grid>          
    </div>
  );
} */





class Login extends Component {
  /* const [values, setValues] = React.useState({
    //password: '',
    showPassword: false
  }); */

  /* constructor(props) {
    super(props);
    this.state = {
      showPassword: false
    }
  } */

  componentDidMount() {
    if (this.txt) {
      this.txt.focus();
    }
    if (isMobile && !isBrowser && !isChrome) {
      // console.log('estoy en un dispositivo')
    }
  }


  renderTextField = (
    { input, label, name, type, withFocus, required, meta: { touched, error } },
  ) => {
    return <div>
      <span style={{ color: "#72727c" }} >{label}</span>
      <span style={{ color: "red" }} >*</span>
      <TextField
        /* < CssTextField*/
        {...input}
        type={!type ? "text" : type}
        variant="outlined"
        autoComplete="off"
        fullWidth
        required={required}
        /* style={{
          '&.MuiOutlinedInput-notchedOutline':{
            borderColor: '#fff',
          }
          root: {
            '&.MuiOutlinedInput-root': {
              '& fieldset': {
                borderColor: 'red',
              },
              '&:hover fieldset': {
                borderColor: 'yellow',
              },
              '&.Mui-focused fieldset': {
                borderColor: 'green',
              },
            }
          }

        }} */
        InputLabelProps={
          {
            style: { color: '#000000' }
          }
        }
        /* InputProps={
          {
            style: { color: '#07f' }
          }
        } */
        color="secondary"
        name={name}
        id={name}
        ref={withFocus && (txt => { this.txt = txt; })}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <PersonIcon style={{
                color: '#b98919'
              }} />
            </InputAdornment>
          ),
        }}
      />
      {touched && error && <span style={{ color: 'red' }}>{error}</span>}
    </div>
  };

  renderTextFieldPassword = (
    { input, id, label, name, type, required, withFocus, meta: { touched, error } },
  ) => {
    const [values, setValues] = React.useState({
      showPassword: false
    });

    /* const handleChange = (prop) => (event) => {
      setValues({ ...values, [prop]: event.target.value });
    }; */



    const handleClickShowPassword = () => {
      setValues({ ...values, showPassword: !values.showPassword });
    };

    /* const handleMouseDownPassword = (event) => {
      event.preventDefault();
    }; */

    return <div>
      <span style={{ color: "#72727c" }} >{label}</span>
      <span style={{ color: "red" }} >*</span>
      <TextField
        /* < CssTextField*/
        {...input}
        type={values.showPassword ? 'text' : 'password'}
        autoComplete="current-password"
        //value={values.password}
        variant="outlined"
        fullWidth
        required={required}
        //onChange={handleChange('password')}
        name={name}
        id={name}
        ref={withFocus && (txt => { this.txt = txt; })}
        color="secondary"
        //onPaste={handleChange}
        InputLabelProps={
          {
            style: { color: '#000000' }
          }
        }
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <LockIcon style={{
                color: '#b98919'
              }} />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={handleClickShowPassword}
              //onMouseDown={handleMouseDownPassword}
              >
                {values.showPassword ? <Visibility /> : <VisibilityOff />}
              </IconButton>
            </InputAdornment>
          )
        }}
      />
      {/* <VisibilityIcon className="reveal" onClick={() => setShown(!shown)} /> */}
      {touched && error && <span style={{ color: 'red' }}>{error}</span>}
    </div>
  };

  render() {
    // const { classes, handleSubmit, submitting, pristine } = this.props;
    const { classes, handleSubmit/* , finguerprint */, valid, pristine } = this.props;
    const now_year = moment().year()
    return (
      <div style={{ overflowY: 'hidden' }}>
        {/* <Container component="main" maxWidth="xl"> */}
        <CssBaseline />
        {
          isMobile ?
            <Grid item xs={12} style={{ padding: 24 }} container justifyContent='center' alignItems='center'>
              <img src={process.env.PUBLIC_URL + '/images/LogoGroup_.svg'} alt="Logo" style={{ width: "50%", marginBottom: 24 }} />
              <Grid item xs={12} style={{ padding: 24, background: "#efefef", borderRadius: 32, height: "fit-content" }}>
                <span style={{ color: "#b98919", fontSize: 18 }}>Bienvenido</span>
                <br />
                <span style={{ color: "#312a5c", fontSize: 28 }}><b>¡Hacemos finanzas Inclusivas!</b></span>
                <br />
                <br />

                <form onSubmit={handleSubmit} id="LoginForm">

                  <Field
                    withFocus
                    name="username"
                    component={this.renderTextField}
                    label="Usuario"
                    required={true}
                    type='text'
                  />
                  <br />
                  <Field
                    name="password"
                    type="password"
                    component={this.renderTextFieldPassword}
                    label="Contraseña"
                    required={true}
                  />
                  <br />
                  <Button
                    type="submit"
                    name="buttonSubmit"
                    disabled={pristine || !valid}
                    fullWidth
                    color='secondary'
                    variant='contained'
                  >
                    Iniciar sesión
                  </Button>
                </form>
                <br />
                <Divider variant="middle" flexItem component={"p"} style={{ border: "1px solid #fff", marginBottom: 16 }} />
                <Grid container className={classes.grid_header}>
                  <Grid item xs={12} sm={12} container justifyContent='center'>
                    <Button
                      fullWidth
                      onClick={() => history.push('/password-recover')}
                      variant='outlined'
                      color='primary'
                    > ¿Olvidó su contraseña?</Button>
                  </Grid>
                  <Grid item xs={12} container justifyContent='center'>
                    <Button
                      variant='outlined'
                      color='primary'
                      onClick={() => history.push('/user-recover')}
                      fullWidth
                    > ¿Olvidó su usuario? </Button>
                  </Grid>
                  <Grid item xs={12} container justifyContent='flex-end'>
                    <Button
                      variant='text'
                      color='primary'
                      onClick={() => history.push('/user-unlock')}
                      startIcon={<LockOpen style={{ fontSize: 12 }} />}
                      style={{ fontSize: 12, textAlign: "end" }}
                    > Desbloquear usuario </Button>
                  </Grid>
                </Grid>
                <Divider variant="middle" flexItem component={"p"} style={{ border: "1px solid #fff", marginBottom: 16 }} />
                <Grid item xs={12} container justifyContent='center'>
                  <Button
                    variant='text'
                    color='primary'
                    onClick={() => history.push('/home')}
                    startIcon={<ArrowBack />}
                  > <span style={{ color: "#72727c" }}>Regresar</span> </Button>
                </Grid>

              </Grid>

            </Grid>
            :
            <Grid container>
              <Grid item xs={6} style={{ height: '100vh', display: "flex", flexDirection: "column", justifyContent: "center" }}>
                <Grid container justifyContent='space-evenly' direction='column' style={{ height: "90%" }}>
                  <img src={process.env.PUBLIC_URL + '/images/LogoGroup_.svg'} alt="Logo" style={{ width: "50%", marginLeft: "10%" }} />

                  <img src={process.env.PUBLIC_URL + '/images/BannerGroup_.svg'} alt="Banner" style={{ width: "60%", margin: "auto" }} />
                  <p style={{ color: "#72727c", textAlign: "center" }} >Todos los derechos reservados © <span style={{ color: "#312a5c", fontWeight: "600" }} >{now_year} Gañansol Cooperativa</span></p>
                </Grid>

              </Grid>
              <Grid item xs={6} container justifyContent='space-evenly' alignItems='center' style={{ backgroundColor: '#b98919' }} >
                <Grid item xs={8} style={{ padding: "16px 32px", background: "#ffffffb3", borderRadius: 32, height: "fit-content" }}>
                  <span style={{ color: "#b98919", fontSize: 25 }}>Bienvenido a</span>
                  <br />
                  <span style={{ color: "#312a5c", fontSize: 36 }}><b>Banca Empresas</b></span>
                  <br />
                  <br />

                  <form onSubmit={handleSubmit} id="LoginForm">

                    <Field
                      withFocus
                      name="username"
                      component={this.renderTextField}
                      label="Usuario"
                      required={true}
                      type='text'
                    />
                    <br />
                    <Field
                      name="password"
                      type="password"
                      component={this.renderTextFieldPassword}
                      label="Contraseña"
                      required={true}
                    />
                    <br />
                    <Button
                      type="submit"
                      name="buttonSubmit"
                      disabled={pristine || !valid}
                      fullWidth
                      color='primary'
                      variant='contained'
                    >
                      Iniciar sesión
                    </Button>
                  </form>
                  <br />
                  {/* <Divider variant="middle" flexItem component={"p"} style={{ border: "1px solid #fff", marginBottom: 16 }} /> */}
                  {/* <Grid container className={classes.grid_header}>
                    <Grid item xs={12} sm={12} container justifyContent='center'>
                      <Button
                        fullWidth
                        onClick={() => history.push('/password-recover')}
                        variant='outlined'
                        color='primary'
                      > ¿Olvidó su contraseña?</Button>
                    </Grid>
                    <Grid item xs={12} container justifyContent='center'>
                      <Button
                        variant='outlined'
                        color='primary'
                        onClick={() => history.push('/user-recover')}
                        fullWidth
                      > ¿Olvidó su usuario? </Button>
                    </Grid>
                    <Grid item xs={12} container justifyContent='flex-end'>
                      <Button
                        variant='text'
                        color='primary'
                        onClick={() => history.push('/user-unlock')}
                        startIcon={<LockOpen style={{ fontSize: 12 }} />}
                        style={{ fontSize: 12, textAlign: "end" }}
                      > Desbloquear usuario </Button>
                    </Grid>

                  </Grid> */}
                  {/* <br></br> */}
                </Grid>

              </Grid>

            </Grid>
        }
        {/* <div className={classes.paper}> */}




        {/* </div> */}


        {/* <Box mt={3}>

          </Box> */}
        {/* </Container> */}
      </div >
    )
  }
}

Login.propTypes = {
  classes: PropTypes.object.isRequired,
  finguerprint: PropTypes.func.isRequired,
  email: PropTypes.string,
  password: PropTypes.string,
};

const LoginReduxForm = reduxForm(
  {
    form: 'Login',
    validate
  }
)(Login)
export default setPropsAsInitial(withStyles(useStyles)(LoginReduxForm))
